module.exports = __webpack_public_path__ + "img/list_outlined_24.29745aa2.svg";